import { Button } from 'styled';
import Model from 'components/Modal';
import { createDocument } from 'apis/customApiHandler';
import { useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { TD, TH } from 'styled/table';
import { saveErrorCreationEvent } from '../../utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';
import { useLocation } from 'react-router-dom';

const Delete = ({ handleClick, fleet, date, getData, page, data}) => {
  const queryClient = useQueryClient();
  const location = useLocation();

  function cpkmDeleteEventFunc(eventName, params) {
    return saveErrorCreationEvent(eventName, "Delete CPKM", "CPKM Upload", location.pathname, params);
  }

  const handleClickDelete = async () => {
    cpkmDeleteEventFunc(ANALYTICS_EVENTS.CLICK_DELETE_CHANGES, { fleet, date });
    try {
      const response = await createDocument('cpkm/delete', {fleet, date});
      if (response) {
        cpkmDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_UPLOAD_CPKM_SUCCESS, { fleet, date });
      }
      queryClient.invalidateQueries('delete-cpkm');
      handleClick();
      getData(page);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error?.message;
      cpkmDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_UPLOAD_CPKM_ERROR, { fleets:fleet, date, errMsg });
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={'Delete CPKM'}
      className="max-w-2xl"
    >
      <div className="p-4">
        <p className="text-red-500 p-5 text-center">
          Are you sure you want to delete this CPKM record?
        </p>
        <table>
          <thead>
            <tr>
            <TH>S.N.</TH>
            <TH>Registration Number</TH>
            <TH>Billed CPKM</TH>
            </tr>
          </thead>
          <tbody>
            {data.cpkms.map((item, index)=> (
            <tr>
              <TD>{index+1}</TD>
              <TD>{item.registrationNumber}</TD>
              <TD>{item.billedCPKM}</TD>
            </tr>
            ))}
          </tbody>
        </table>

        <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            No
          </Button>
          <Button type="button" bgPrimary onClick={() => handleClickDelete()}>
            Yes
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default Delete;
